<script>
  import Button from "./Button.svelte";
  import TextInput from "./TextInput.svelte";

  export let key;
  export let url;
  export let title;
  export let description;
  export let submitButtonText;

  const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  let email = "";

  $: validInput = emailRegex.test(email);

  let loading = false;
  let succeeded = false;

  const submitForm = async () => {
    loading = true;
    try {
      if (validInput) {
        const token = await grecaptcha.execute(key, { action: "submit" });
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'g-recaptcha': token,
            'cl-email': email,
            'cl-form': 'avoid_crypto_taxes'
          }
        });

        succeeded = res.ok;
      }
    } catch (error) {
      succeeded = false;
    }
    finally {
      loading = false;
    }
  };
</script>

<div class="flex flex-col gap-y-4">
  {#if succeeded}
    <div>
      <p class="text-lg font-medium font-sans text-neutral-1200">
        Thank you for downloading!
      </p>
      <p class="text-base font-sans font-light text-neutral-200">
        We'll send the tax guide to your email shortly. In the meantime, you can start importing your cryptocurrency transactions with <a href="https://app.coinledger.io/?referrer=coinledger" target="_blank" class="text-primary-500 font-bold">CoinLedger</a> for free.
      </p>
    </div>
  {:else}
    <div class="text-xl font-medium font-sans text-neutral-1200">
      {title}
    </div>
    <div class="text-base font-sans font-light text-neutral-200">
      {description}
    </div>

    <div class="flex flex-col gap-y-1">
      <TextInput
        bind:value={email}
        placeholder="Type your email address"
      />

      {#if (email && !validInput)}
        <div class="text-danger-300 text-sm">
          Please enter a valid email address
        </div>
      {/if}
    </div>

    <div class="w-min">
      <Button title={submitButtonText} showLoadingIndicator={loading} onClick={submitForm} disabled={(email && !validInput)} />
    </div>
  {/if}

  <div class="mt-4">
    <img src="https://uploads-ssl.webflow.com/614c99cf4f23708b27a37503/63286cdfbe0157717c7a6d72_five_stars.png" alt="five stars"/>
    <div class="text-xs font-sans">
      Downloaded by 10,000+ investors
    </div>
  </div>
</div>
